<template>
      <div class="home" >
        <div class="container p-l-r-0 container-shadow">
            <div class="row">
     <UserProfile></UserProfile>
    </div>
    <div class="row content-holder">
        <div class="col-sm-3 col-md-3 col-xs-3 dashboard-sec-left" >
            <LeftNav :type="'grievances'"/>
        </div>
        <div class="col-sm-9 col-md-9 col-xs-9 dashboard-sec-right" >
             <p class="welcome-text">
                    Want to raise a complaint or clarify any queries about your RoA product?<br>
Chat with our team and we will ensure speedy assistance for positive and quick grievance redressal.
                </p>
            <div class="col chat-box">
               
            <div class="col chat-window thin-scroll">
            <div v-for="msg in chat" :key="msg.id" >
                <div class="row m-t-30" v-if="msg.sender=='admin'">
                    <div class="col-sm-7 message-box-inner">
                        <div class="person-img user-img">
                            <img src="../../assets/roa_icon.png" class="img-responsive">
                        </div>
                        <div class="person-text">
                            <small class="msg-details">{{msg.date }}</small>
                            <p>
                                {{msg.message}}
                            </p>
                        </div>
                        
                        
                    </div>
                </div>
                <div class="row m-t-30" v-else>
                    <div class="col-sm-5">
                    </div>
                    <div class="col-sm-7 message-box-inner chat-right-me">

                        <div class="person-text1">
                            <small class="msg-details">{{msg.date }}</small>
                            <p>{{msg.message}}</p>
                        </div>
                        <div class="person-img1 user-img">
                            <img  :src="current_user_name ? 'https://ui-avatars.com/api/?name='+current_user_name :'../assets/user-icon.png'"  class="img-responsive">
                        </div>
                    </div>
                </div>
            </div>
             <div id="chat-end"></div>
        </div>
        </div>
        <div class="row m-t-30">
                
            <div class="col-sm-12 col-xs-12">
                <div class="form-group textarea-form chat-send-box">
                    <ResizableTextarea ref="resize">
                        <textarea class="form-control" rows="2" id="comment"  v-model="send.message" placeholder="Type your Message"  v-on:keyup="keyHandler()"></textarea>
                    </ResizableTextarea>
                    <a  href="javascript://" class="btn-send send_message" @click="post()" style="margin-right: 0px; bottom: -10px; color:#000000;" v-bind:class="{active:chat_active}"><svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="paper-plane" class="svg-inline--fa fa-paper-plane fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"></path></svg></a>
                </div>
                <div class="col-sm-12" style="text-align:left;padding-left:20px;">
                    <span class="text-danger">
                        {{msg_err}}
                    </span>
                </div>
               <!--  <div class="form-group textarea-form">
                    <textarea class="form-control" rows="3" id="comment"  v-model="send.message" placeholder="Type your Message" ></textarea>
                </div> -->
               
            </div>
        </div>
        <!--  <div class="row m-b-40 ">
                    <div class="col-sm-1"></div>
                    <div class="col-sm-11">
                        <div class="send-img">
                            <a href="javascript://">
                            <img src="../../../assets/images/icon-15.png" class="img-responsive"  @click="post()">
                            </a>
                        </div>
                        <div>
                        <span class="text-danger">
                            {{msg_err}}
                        </span>
                        </div>
                    </div>
                </div> -->
        </div>
        
    </div>
</div>
  </div>
</template>
<script>
import LeftNav from "../layouts/leftNav.vue"
import UserProfile from "../layouts/profile-header.vue"
import grievances from '../../services/grievances'
import ls from '../../services/ls'
import ResizableTextarea from "../../components/ResizableTextarea";
export default {
    name:'grievances-index',
     components: {
        LeftNav,
        UserProfile,
        ResizableTextarea
    },
    data() {
        return {
            send_err:false,
            current_user_name:ls.get('_u_name'),
            msg_err:'',
            send: {
                sender: 'user',
                message: '',
                to:1,
                read:0,
                from:ls.get('_u_unique'),
            },
            chat:{},
            chat_active:false
        }
    },
    methods: {
        post(){
            if(this.send.message!=''){
                grievances.post(this.send)
                            .then(() =>{
                                this.send.message=''
                                // console.log(response.data)
                                this.get();
                            })
            }else{
                this.msg_err='Please enter your message';
                return false
            }
        },
        get(){
             grievances.get({from:'grievances'})
                .then(response =>{
                    this.chat=response.data.chat
                     const el = document.getElementById('chat-end');
                        el.scrollIntoView({behavior: "smooth"});
                })
        },
        keyHandler(){
            if(this.send.message != ""){
                this.chat_active = true;
            }else{
             this.chat_active = false;
            }
        }
    },
    created(){
       this.get()
    }
}
</script>